import { render, staticRenderFns } from "./BCOptionalFeaturesVOXExternalDevice.vue?vue&type=template&id=af56d6fe"
import script from "./BCOptionalFeaturesVOXExternalDevice.vue?vue&type=script&lang=js"
export * from "./BCOptionalFeaturesVOXExternalDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports